module.exports = __webpack_public_path__ + "img/menucn_5_3.07532f7d.svg";